import React, { useRef, useEffect } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';

function ImportClientExcel({ sendDataToParent, logs = [], resetFile = 0 }) {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selected = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    if (selected) {
      sendDataToParent({ file: selected });
    } else {
      sendDataToParent({ file: null });
    }
  };

  // Clear file input whenever resetFile counter changes (after import)
  useEffect(() => {
    if (resetFile > 0 && fileInputRef.current) {
      fileInputRef.current.value = '';
      sendDataToParent({ file: null });
    }
  }, [resetFile]);

  const downloadSample = async () => {
    try {
      const url = getApiBaseUrl() + '/downloadClientSampleXls';
      const response = await axios.get(url, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = 'ClientImportSample.xls';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch (e) {
      console.error('Failed to download sample XLS:', e);
    }
  };

  return (
    <div className="container">
      <div className="row mb-3">
        <div className="col-10">
          <label htmlFor="excelFile" className="form-label">Select Excel file</label>
          <input
            ref={fileInputRef}
            id="excelFile"
            type="file"
            accept=".xlsx,.xls"
            className="form-control"
            onChange={handleFileChange}
          />
        </div>
        <div className="col-2 mt-2 d-flex align-items-end">
          <button type="button" className="btn btn-submit btn-sm" onClick={downloadSample}>Download Sample</button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 text-muted">
          <small>Accepted formats: .xlsx, .xls, .csv</small>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-12">
          {Array.isArray(logs) && logs.length > 0 && (
            <div className="row mt-3">
              <div className="col-12">
                <div className="table-responsive" style={{ maxHeight: '260px', overflowY: 'auto', border: '1px solid #e9ecef', borderRadius: '4px' }}>
                  <table className="table table-sm">
                    <thead style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}>
                      <tr>
                        <th>#</th>
                        <th>Client Name</th>
                        <th>Status</th>
                        <th>Message</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logs.map((l, idx) => (
                        <tr key={idx}>
                          <td>{l.index}</td>
                          <td>{l.clientName || '-'}</td>
                          <td className={l.success ? 'text-success' : 'text-danger'}>{l.success ? 'Inserted' : 'Failed'}</td>
                          <td>{l.message}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      
    </div>
  );
}

export default ImportClientExcel;
